import client from './client';
import type { ApiResponse, LoginResponse, AuthUser, TokenResponse } from './types';

export async function getLoginUrl(): Promise<ApiResponse<LoginResponse>> {
  return client.get('/auth/login');
}

export async function getCurrentUser(): Promise<ApiResponse<AuthUser>> {
  return client.get('/auth/me');
}

export async function refreshToken(refreshToken: string): Promise<ApiResponse<TokenResponse>> {
  return client.post('/auth/refresh', { refreshToken });
}

export async function logout(): Promise<ApiResponse<null>> {
  return client.post('/auth/logout');
}
